import {
  ACTION_GET_AUDIT_EVENTS,
  ACTION_GET_AUDIT_EVENTS_SUCCESS,
  ACTION_GET_AUDIT_EVENTS_FAILURE,
  ACTION_GET_MORE_AUDIT_EVENTS,
  ACTION_GET_MORE_AUDIT_EVENTS_SUCCESS,
  ACTION_GET_MORE_AUDIT_EVENTS_FAILURE,
  ACTION_EMPTY_AUDIT_EVENTS,
  API_CALL,
} from '../../configs/ActionTypes';

import { Dispatch } from 'redux';

import { enqueueSnackbarHandler } from '../Status';

export function getAuditEvents(params?: any) {
  return (dispatch: Dispatch) => {
    dispatch({ type: ACTION_GET_AUDIT_EVENTS, payload: null });

    dispatch({
      type: API_CALL,
      payload: {
        call: 'audit-events',
        method: 'get',
        data: params || {},
        success: (response: any) => {
          dispatch({ type: ACTION_GET_AUDIT_EVENTS_SUCCESS, payload: response });
        },
        fail: (error: any) => {
          enqueueSnackbarHandler(dispatch, error.payload, 'error');
          dispatch({ type: ACTION_GET_AUDIT_EVENTS_FAILURE, payload: error });
        },
      },
    });
  };
}

export function getMoreAuditEvents(params: any, cursor: { id: string, createdAt: string }) {
  return (dispatch: Dispatch) => {
    dispatch({ type: ACTION_GET_MORE_AUDIT_EVENTS, payload: null });

    dispatch({
      type: API_CALL,
      payload: {
        call: 'audit-events',
        method: 'get',
        data: { ...params, 'cursor[id]': cursor.id, 'cursor[createdAt]': cursor.createdAt },
        success: (response: any) => {
          dispatch({ type: ACTION_GET_MORE_AUDIT_EVENTS_SUCCESS, payload: response });
        },
        fail: (error: any) => {
          enqueueSnackbarHandler(dispatch, error.payload, 'error');
          dispatch({ type: ACTION_GET_MORE_AUDIT_EVENTS_FAILURE, payload: error });
        },
      },
    });
  };
}

export function emptyAuditEvents() {
  return (dispatch: Dispatch) => {
    dispatch({ type: ACTION_EMPTY_AUDIT_EVENTS, payload: null });
  };
}
